import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOWartZyklusListStatus: 'idle',
    loadTOWartZyklusListError: undefined as any,
    loadTOWartZyklusListLastArgs: undefined as any,
    loadTOWartZyklusStatus: 'idle',
    loadTOWartZyklusError: undefined as any,
    saveTOWartZyklusStatus: 'idle',
    saveTOWartZyklusError: undefined as any,
    deleteTOWartZyklusStatus: 'idle',
    deleteTOWartZyklusError: undefined as any,

    tOWartZyklusList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOWartZyklusList = createAsyncThunk('toWartZyklusSlice/loadTOWartZyklusList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toWartZyklusSlice.loadTOWartZyklusListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristowartzyklus/?action=gte&TOID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOWartZyklusListStatus } = getState().toWartZyklusSlice
        return loadTOWartZyklusListStatus !== 'pending'
    }
})

export const loadTOWartZyklus = createAsyncThunk('toWartZyklusSlice/loadTOWartZyklus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristowartzyklus/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOWartZyklusStatus } = getState().toWartZyklusSlice
        return loadTOWartZyklusStatus !== 'pending'
    }
})

export const saveTOWartZyklus = createAsyncThunk('toWartZyklusSlice/saveTOWartZyklus', async ({ tOWartZyklus }: any, { rejectWithValue }: any) => {
    let promises = []
    if (tOWartZyklus?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristowartzyklus/${ tOWartZyklus?.HDR_ID }/`,
            prepareData(tOWartZyklus),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristowartzyklus/`,
            prepareData(tOWartZyklus),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOWartZyklusStatus } = getState().toWartZyklusSlice
        return saveTOWartZyklusStatus !== 'pending'
    }
})

export const deleteTOWartZyklus = createAsyncThunk('toWartZyklusSlice/deleteTOWartZyklus', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nuristowartzyklus/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOWartZyklusStatus } = getState().toWartZyklusSlice
        return deleteTOWartZyklusStatus !== 'pending'
    }
})

const TOWartZyklusSlice = createSlice({
    name: 'toWartZyklusSlice',
    initialState,
    reducers: {
        resetloadTOWartZyklusListError: (state) => {
            state.loadTOWartZyklusListError = undefined
        },
        resetloadTOWartZyklus: (state) => {
            state.formItem = undefined
            state.loadTOWartZyklusError = undefined
        },
        resetloadTOWartZyklusError: (state) => {
            state.loadTOWartZyklusError = undefined
        },
        resetsaveTOWartZyklus: (state) => {
            state.formItem = undefined
            state.saveTOWartZyklusError = undefined
        },
        resetsaveTOWartZyklusError: (state) => {
            state.saveTOWartZyklusError = undefined
        },
        resetdeleteTOWartZyklusError: (state) => {
            state.deleteTOWartZyklusError = undefined
        },
        removeFromTOWartZyklusListById: (state, action) => {
            state.tOWartZyklusList = state.tOWartZyklusList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTOWartZyklusListByIds: (state, action) => {
            state.tOWartZyklusList = state.tOWartZyklusList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tOWartZyklusList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOWartZyklusListStatus = 'preloaded'
            state.loadTOWartZyklusListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tOWartZyklusList = []
            state.loadTOWartZyklusListStatus = 'idle'
            state.loadTOWartZyklusListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOWartZyklusList.pending, (state) => {
            state.loadTOWartZyklusListStatus = 'pending'
            state.loadTOWartZyklusListError = undefined
        })
        builder.addCase(loadTOWartZyklusList.fulfilled, (state, action) => {
            state.loadTOWartZyklusListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOWartZyklusListLastArgs = action.payload.args

            {
                state.tOWartZyklusList = action.payload.data

            }
        })
        builder.addCase(loadTOWartZyklusList.rejected, (state, action) => {
            state.loadTOWartZyklusListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOWartZyklusListError = action.error.message
            } else {
                state.loadTOWartZyklusListError = action.payload
            }
        })

        builder.addCase(loadTOWartZyklus.pending, (state) => {
            state.loadTOWartZyklusStatus = 'pending'
            state.loadTOWartZyklusError = undefined
        })
        builder.addCase(loadTOWartZyklus.fulfilled, (state, action) => {
            state.loadTOWartZyklusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOWartZyklusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOWartZyklusList.push(newItem) }
                else { state.tOWartZyklusList[i] = { ...state.tOWartZyklusList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOWartZyklus.rejected, (state, action) => {
            state.loadTOWartZyklusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOWartZyklusError = action.error.message
            } else {
                state.loadTOWartZyklusError = action.payload
            }
        })

        builder.addCase(saveTOWartZyklus.pending, (state) => {
            state.saveTOWartZyklusStatus = 'pending'
            state.saveTOWartZyklusError = undefined
        })
        builder.addCase(saveTOWartZyklus.fulfilled, (state, action) => {
            state.saveTOWartZyklusStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOWartZyklusList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOWartZyklusList.push(newItem) }
                else { state.tOWartZyklusList[i] = { ...state.tOWartZyklusList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOWartZyklus.rejected, (state, action) => {
            state.saveTOWartZyklusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOWartZyklusError = action.error.message
            } else {
                state.saveTOWartZyklusError = action.payload
            }
        })

        builder.addCase(deleteTOWartZyklus.pending, (state) => {
            state.deleteTOWartZyklusStatus = 'pending'
            state.deleteTOWartZyklusError = undefined
        })
        builder.addCase(deleteTOWartZyklus.fulfilled, (state, action) => {
            state.deleteTOWartZyklusStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.tOWartZyklusList = state.tOWartZyklusList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.tOWartZyklusList = state.tOWartZyklusList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOWartZyklus.rejected, (state, action) => {
            state.deleteTOWartZyklusStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOWartZyklusError = action.error.message
            } else {
                state.deleteTOWartZyklusError = action.payload
            }
        })

    }
})

export const {
    resetloadTOWartZyklusListError,
    resetloadTOWartZyklus,
    resetloadTOWartZyklusError,
    resetsaveTOWartZyklus,
    resetsaveTOWartZyklusError,
    resetdeleteTOWartZyklusError,
    removeFromTOWartZyklusListById,
    removeFromTOWartZyklusListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TOWartZyklusSlice.actions
export default TOWartZyklusSlice.reducer
